import { FETCH_USER_GENERAL_INFO, LOGOUT } from '../constants/ActionTypes';
import {
  _PENDING,
  _REJECTED,
  _FULFILLED
} from '../constants/PromiseMiddleware';

const defaultStore = {
  menu: {},
  isFetching: false
};

const menu = (state = defaultStore, action) => {
  switch (action.type) {
    case LOGOUT:
      return defaultStore;

    case FETCH_USER_GENERAL_INFO:
      return { ...state };

    case FETCH_USER_GENERAL_INFO + _PENDING:
      return { ...state, isFetching: true };

    case FETCH_USER_GENERAL_INFO + _REJECTED:
      return { ...state, isFetching: false };

    case FETCH_USER_GENERAL_INFO + _FULFILLED:
      return {
        ...state,
        isFetching: false,
        menu: action.payload.data.result.menu
      };

    default:
      return state;
  }
};

module.exports = menu;



// WEBPACK FOOTER //
// ./reducers/menuMapReducer.js